import React from "react";
import { Link } from "react-router-dom";

const PageNotFound = () => {
  return (
    <div className="flex justify-center ">
      <div className="text-center mt-14">
        <img src={"/icons/Warning.png"} alt="Centered Content" className="mx-auto mb-4" />
        <p className="text-sm text-gray-400 w-[200px]">
          Page Not Found !!
          <Link to={"/"} className="font-bold ">
            Go to Home
          </Link>
        </p>
      </div>
    </div>
  );
  //
};

export default PageNotFound;
